<main id="dashboard-operator">
  <h3>Willkommen, {{ user?.firstName }}</h3>
  <form [formGroup]="formService.form" (keydown.enter)="searchForTerm()">
    <div class="input-group mb-3 shadow-sm">
      <input type="text" class="form-control" id="searchTerm" formControlName="searchTerm" placeholder="Suche nach GUID, EVSE-ID, CS-ID, Kundennummer, Name, Firma, Bezeichner, Transaktion, RFID...">
      <button class="btn btn-primary" type="button" (click)="searchForTerm();"> <app-svg source="icons/feather/search" width="18"></app-svg></button>
    </div>
    <div *ngIf="this.hasError" class="alert alert-warning">
      <span i18n="@@MinLengthRequiredError">Der Suchbegriff muss mindestens 3 Zeichen lang sein.</span>
    </div>
  </form>
  <div class="searchResult card" *ngIf="this.searchResult">
    <span class="ps-2 pt-2 fs-4">Suchergebnisse für ("{{this?.searchTerm}}"):</span>
    <div *ngIf="this.searchCSResult?.length <=0 && this.searchCUResult?.length <=0 && this.searchTRResult?.length <=0 && this.searchRFResult?.length <= 0" class="m-2 mb-3">
      <span>Keine Einträge gefunden.</span>
    </div>
    <div *ngIf="this.searchCSResult?.length >= 1 " class="m-2 border border-1 rounded-2 mb-3">
      <div class="p-2" *ngIf="this.searchCSResult.length>=1">
        <app-svg source="icons/feather/charging-station" width="24"></app-svg><span class="fw-bold ps-2">&nbsp;Ladestation ({{this.searchCSResult.length}})</span>
      </div>
      <table class="table">
        <thead>
          <tr>
            <td><strong>ID</strong></td>
            <td><strong>CS-ID</strong></td>
            <td><strong>Name</strong></td>
            <td><strong>Hersteller</strong></td>
            <td><strong>Modell</strong></td>
            <td><strong>EVSE-ID</strong></td>
            <td class="text-right"><strong>eRoaming</strong></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cs of this.searchCSResult; let index = index" routerLink="/operator/chargingstation/{{cs.id}}" style="cursor:pointer" class="linkTableRow">
            <td>{{cs.id}}</td>
            <td>{{cs.csId}}</td>
            <td>{{cs.name}}</td>
            <td>{{cs.manufacturer?.name}}</td>
            <td>{{cs.model?.name}}</td>
            <td>
              <ng-element *ngFor="let cp of cs.chargingPoints; index as i">
                <span class="d-block" *ngIf="cs.chargingPoints[i].evseId">{{cs.chargingPoints[i].evseId}}</span>
              </ng-element>
            </td>
            <td class="text-right">{{cs?.isHubjectAvailable}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="this.searchTRResult?.length >= 1" class="m-2 border border-1 rounded-2 mb-3">
      <div class="p-2"><app-svg source="icons/feather/zap" width="24"></app-svg><span class="fw-bold ps-2">&nbsp;Transaktionen ({{this.searchTRResult.length}})</span></div>
      <table class="table">
        <thead>
          <tr>
            <td><strong>Trans-Id</strong></td>
            <td><strong>RfID</strong></td>
            <td><strong>Lademenge</strong></td>
            <td><strong>Start</strong></td>
            <td><strong>Ende</strong></td>
            <td><strong>Ladestation</strong></td>
            <td class="text-right"><strong>Status</strong></td>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tr of this.searchTRResult; let index = index" routerLink="/operator/{{tr.id}}" style="cursor:pointer" class="linkTableRow">
            <td>{{tr?.transactionId}}</td>
            <td>{{tr?.rfidCardIdTag}}</td>
            <td>{{tr?.meterAmount | kwh}} kWh</td>
            <td style="width:160px;">{{tr?.startTimestamp | date: 'medium':'+0100'}}</td>
            <td style="width:160px;">{{tr?.stopTimestamp | date: 'medium':'+0100'}}</td>
            <td>{{tr?.chargingStationName}}</td>
            <td class="text-right">{{tr?.successMessage}}</td>

          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="this.searchCUResult?.length >= 1" class="m-2 border border-1 rounded-2 mb-3">
      <div class="p-2"><app-svg source="icons/feather/user" width="24"></app-svg><span class="fw-bold ps-2">&nbsp;Kunden({{this.searchCUResult.length}})</span></div>
      <table class="table">
        <thead>
          <tr>
            <td><strong>ID</strong></td>
            <td><strong>Kunden-Nr.</strong></td>
            <td><strong>Firma</strong></td>
            <td><strong>Bezeichner</strong></td>
            <td><strong>Name</strong></td>
            <td><strong>Anzahl Benutzer</strong></td>
            <td><strong>Anzahl Ladestationen</strong></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cu of this.searchCUResult; let index = index" routerLink="/customer/{{cu.id}}/dashboard" style="cursor:pointer" class="linkTableRow">
            <td>{{cu.id}}</td>
            <td>{{cu?.customerId}}</td>
            <td>{{cu?.company}}</td>
            <td>{{cu?.internalDescription}}</td>
            <td>{{cu?.fullName}}</td>
            <td>{{cu?.users}}</td>
            <td>{{cu?.chargingStations}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="this.searchRFResult?.length >= 1" class="m-2 border border-1 rounded-2 mb-3">
      <div class="p-2"><app-svg source="icons/feather/rfid-card" width="24"></app-svg><span class="fw-bold ps-2">&nbsp;RFID-Karten ({{this.searchRFResult.length}})</span></div>
      <table class="table">
        <thead>
          <tr>
            <td><strong>ID</strong></td>
            <td><strong>RFID</strong></td>
            <td><strong>Kunden-Nr.</strong></td>
            <td><strong>Vorname</strong></td>
            <td><strong>Nachname</strong></td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rf of this.searchRFResult; let index = index" routerLink="/customer/{{rf?.customerId}}/rfid/edit/{{rf?.id}}" style="cursor:pointer" class="linkTableRow">
            <td>{{rf.id}}</td>
            <td>{{rf?.idTag}}</td>
            <td>{{rf?.customerId}}</td>
            <td>{{rf?.userFirstName}}</td>
            <td>{{rf?.userLastName}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="summary">
    <a class="card" [routerLink]="['/customer']">
      <h1>{{ customers }}</h1>
      <app-svg source="icons/feather/customer" width="48"></app-svg>
      <span>Kunden</span>
    </a>

    <a class="card" [routerLink]="['/users']">
      <h1>{{ users }}</h1>
      <app-svg source="icons/feather/user" width="48"></app-svg>
      <span>Benutzer</span>
    </a>

    <ng-template #statusToolTip>
      <div *ngFor="let cs of chargingStations; index as i; first as isFirst" class="text-start">
        <ng-container [ngSwitch]="cs.status">
          <span *ngSwitchCase="'Unregistered'">Unregistriert: {{cs.count}}</span>
          <span *ngSwitchCase="'Available'">Bereit: {{cs.count}}</span>
          <span *ngSwitchCase="'Charging'">Lädt: {{cs.count}}</span>
          <span *ngSwitchCase="'Faulted'">Fehler: {{cs.count}}</span>
          <span *ngSwitchCase="'Finishing'">Ladevorgang beendet: {{cs.count}}</span>
          <span *ngSwitchCase="'Preparing'">in Vorbereitung: {{cs.count}}</span>
          <span *ngSwitchCase="'Reserved'">Reserviert: {{cs.count}}</span>
          <span *ngSwitchCase="'SuspendedEV'">vom Fahrzeug pausiert: {{cs.count}}</span>
          <span *ngSwitchCase="'SuspendedEVSE'">von Ladepunkt pausiert: {{cs.count}}</span>
          <span *ngSwitchCase="'Unavailable'">Nicht verfügbar: {{cs.count}}</span>
          <span *ngSwitchCase="'Offline'">Offline: {{cs.count}}</span>
          <span *ngSwitchDefault>Unbekannter Status: {{cs.count}}</span>
        </ng-container>
      </div>
    </ng-template>

    <a class="card" [routerLink]="['/allstations/summary']" placement="left" [ngbTooltip]="statusToolTip">
      <h1>{{total}}</h1>
      <app-svg source="icons/feather/charging-station" width="48"></app-svg>
      <span>Ladestationen</span>
    </a>

    <a class="card" [routerLink]="['/blackboxes']" *ngIf="!isSupporter">
      <h1>{{ blackboxes }}</h1>
      <app-svg source="icons/feather/cpu" width="48"></app-svg>
      <span>Blackboxen</span>
    </a>

    <a class="card" [routerLink]="['/csprofiles']" *ngIf="!isSupporter">
      <h1>{{ models }}</h1>
      <span>Ladepunktprofile</span>
      <app-svg source="icons/feather/box" width="48"></app-svg>
    </a>

    <a class="card" [routerLink]="['/statusnotifications']">
      <h1>{{ notifications }}</h1>
      <app-svg source="icons/feather/alert-triangle" width="48"></app-svg>
      <span>Statusmeldungen</span>
    </a>
    </div>
    <app-dashboard-offlineSince></app-dashboard-offlineSince>

</main>
<router-outlet></router-outlet>
